<mat-form-field
  class="select-classic"
  appearance="outline"
>
  <mat-select
    (valueChange)="dateChanged($event)"
    [disabled]="disabled()"
    [value]="dateRangeId()"
    panelClass="single-select-overlay"
  >
    <mat-select-trigger>
      @if (customRange(); as customRange) {
        {{ customRange.start | date }} - {{ customRange.end | date }}
      } @else {
        <ng-container [ngPlural]="dateRangeId()">
          <ng-template ngPluralCase="=-1">Custom</ng-template>
          <ng-template ngPluralCase="=0">Today</ng-template>
          <ng-template ngPluralCase="=1">Last 24 hours</ng-template>
          <ng-template ngPluralCase="other">Last {{ dateRangeId() }} days</ng-template>
        </ng-container>
      }
    </mat-select-trigger>

    @for (preset of presetOptions(); track preset) {
      <mat-option [value]="preset">{{ presetLabels[preset] }}</mat-option>
    }

    @if (config().customRange) {
      <mat-option
        (click)="trigger.openMenu()"
        [value]="eAvsDateRangeIds.CUSTOM"
      >
        Custom
      </mat-option>
    }
  </mat-select>

  <mat-icon
    class="arrow-down"
    fontIcon="keyboard_arrow_down"
    matSuffix
  />
</mat-form-field>

<div
  class="invisible"
  [matMenuTriggerFor]="menu"
  #trigger="matMenuTrigger"
></div>

<mat-menu
  class="max-w-max"
  (closed)="panelClosed()"
  #menu="matMenu"
>
  <div
    class="mt-2 w-[37rem]"
    (click)="$event.stopPropagation()"
  >
    <avs-calendar
      class="min-h-[21rem]"
      [maxDate]="maxDate()"
      [minDate]="minDate()"
      [value]="customRange()"
    />

    <div class="flex justify-end gap-2 mx-2">
      <button
        (click)="trigger.closeMenu()"
        matButton
      >
        Cancel
      </button>
      <button
        class="btn-green btn-medium"
        (click)="customRange.set(calendar().range()); trigger.closeMenu()"
        [disabled]="!calendar().range().end"
        matButton
      >
        Apply
      </button>
    </div>
  </div>
</mat-menu>
